export const appUrl = "https://mosymphony-cmo-internal.collabrix.co"; //'https://sandbox-aws-sh2.schrocken.io';  //sh2
export const smlUrl = "https://mosymphony-cmo-internal.collabrix.co"; //'https://sandbox-aws.schrocken.io'
export const AnalyticsKey = "UA-171452508-1";
export const CaptchaSiteKey = "6Legf8oZAAAAAOxXKdJX-eBfOoHk5ppgUhRkUwZm";
export const azureADClientID = "9816eb16-5bad-4a6d-bda6-3cb2af5bbc1a";
export const azureADTenantID = "ecfd6ff7-e355-401d-a64e-4e38f61f78cc";
export const adobeClientID = "7ea838bb450c4a488a7de2bea6ebd68f";
export const associateCMOsRoles = [8, 2, 31, 32, 19];
export const associateWarehouseRoles = [33];
export const pingClientID = "";
export const pingClientSecret = ""
export const pingOAuthUrl = "https://sso-qa.bms.com:443/auth/oauth2/authorize";
export const digitizationApiKey = "OStdJyfwQF1i6mlZ5T83D5yUxAfpug928LdZBQd4";
export const digitizationAWSDataApiUrl = "https://dxldxgjiec.execute-api.us-west-2.amazonaws.com/dev";
export const sponsorHelpUrlRedirect  = "https://sites.bms.com/:u:/r/sites/POCollaboration/Shared%20Documents/General/IT%20Project%20-%20CMO%20Direct%20Connect/08%20Training/CMO%20Direct%20Connectivity%20WI%20(%20work%20Instructions%20)/Consolidated%20WI%20(Work%20Instructions)/MoSymphony%20WI%20Agent.agent?csf=1&web=1&e=yKV0Ta"
export const raiseTicketUrlRedirect = "https://collabrix-jsm.atlassian.net/servicedesk/customer/portal/1/group/34/create/67";
